import template from './tdar-availability-request-detail.html.twig';
import './tdar-availability-request-detail.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Shopware.Component.register('tdar-availability-request-detail', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            item: null,
            isLoading: false,
            showDeleteModal: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdar_availability_request');
        },

        requestId() {
            return this.$route.params.id;
        },
    },

    created() {
        this.loadEntity();
    },

    methods: {
        loadEntity() {
            this.isLoading = true;

            this.repository.get(this.requestId, Shopware.Context.api).then((res) => {
                this.item = res;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        setStatus(status) {
            if (!this.item) {
                return;
            }
            this.item.status = status;
            this.repository.save(this.item, Shopware.Context.api).then(() => {
                this.loadEntity();
                this.createNotificationSuccess({
                    message: this.$tc('TopdataAvailabilityRequestSW6.admin.saved'),
                });
            });
        },

        statusVariant(status) {
            if (status === 'done') {
                return 'success';
            }
            if (status === 'spam') {
                return 'danger';
            }
            return 'info';
        },

        statusLabel(status) {
            if (status === 'done') {
                return this.$tc('TopdataAvailabilityRequestSW6.admin.statusDone');
            }
            if (status === 'spam') {
                return this.$tc('TopdataAvailabilityRequestSW6.admin.statusSpam');
            }
            return this.$tc('TopdataAvailabilityRequestSW6.admin.statusNew');
        },

        onDelete() {
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
        },

        onConfirmDelete() {
            if (!this.item) {
                return;
            }
            const id = this.item.id;
            this.repository.delete(id, Shopware.Context.api).then(() => {
                this.showDeleteModal = false;
                this.$router.push({ name: 'tdar.availability.request.list' });
            });
        },
    },
});
